export default __webpack_public_path__ + "static/media/Arcade-Lite-img.93301ad1.png";